module.exports = __webpack_public_path__ + "img/iconLiShiBanGongDaoZha.b03d5ce8.svg";